/**
 * This module is used to detect and validate international phone input fields.
 * Uses 'intl-tel-input' available through vendor.js <–> WebPack
 */

import 'intl-tel-input';
import {readCookie} from "../helpers/born.utils";

export default class {
	constructor(query) {
		//let siteSelectedCountry = $('select#countrySelectorList :selected').data('country'),
		let siteSelectedCountry = 'ae',
			telInputs = document.querySelectorAll(query),
			excludeCountries = [];
        
        try {
            var selectorEl = $('select#countrySelectorList :selected');
            var currentSite = selectorEl.length>0?selectorEl.data('country'):false;
            if(!currentSite) {
                 currentSite  = readCookie('preferredCountry');
            }
            if(currentSite && currentSite.toUpperCase() == 'LB') {
                excludeCountries.push('il');
            }
        } catch (e) {
        }
        
		// assign handlers to each phone input, needs to be individual to detect country per form
		[].forEach.call(telInputs, function(telInput) {
			let $telInput = $(telInput),
				formCountry = $telInput.closest('form').find('input.country, select.country').val(),
				selectedCountry = formCountry ? formCountry : siteSelectedCountry;

			$telInput.intlTelInput({
				initialCountry: selectedCountry,
				preferredCountries: ["ae"],
				excludeCountries:excludeCountries,
				utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/19.5.7/js/utils.js',
				customPlaceholder: function(selectedCountryPlaceholder) {
					return '\u200E' + selectedCountryPlaceholder;
				}
			});

			this.setDummyPhone(telInput);
		}.bind(this));
	}

	/**
	 * Update a hidden phone field with the full phone number
	 * Needed cause by default the country code is hidden.
	 */
	setDummyPhone(originalPhone) {
		let $originalPhone = $(originalPhone),
			dummyPhone = document.createElement('input');

		dummyPhone.type = 'hidden';
		dummyPhone.name = originalPhone.name;

		originalPhone.name = originalPhone.name + '--dummy';
		originalPhone.parentNode.appendChild(dummyPhone);

		$originalPhone.closest('form').on('submit', function(){
			var originalPhoneNumber = $originalPhone.intlTelInput('getNumber');
			if (!originalPhoneNumber.length) {
				originalPhoneNumber = $originalPhone.val();
			}

			dummyPhone.value = originalPhoneNumber;
		});
	}
}



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/modules/module.intl-tel-input.js